import React from 'react';
import LandingPageGenerator from './components/LandingPageGenerator';
import './App.css';

function App() {
  return (
    <div className="App">
      <LandingPageGenerator />
    </div>
  );
}

export default App;
